import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FirstNamePipe } from './pipes/first-name.pipe'
import { FromNowPipe } from './pipes/from-now.pipe'
import { TranslatePendencyTreatmentStatusPipe } from './pipes/pendency-treatment-status.pipe'
import { RemainingTimePipe } from './pipes/remaining-time.pipe'

@NgModule({
  declarations: [
    FirstNamePipe,
    FromNowPipe,
    RemainingTimePipe,
    TranslatePendencyTreatmentStatusPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FirstNamePipe,
    FromNowPipe,
    RemainingTimePipe,
    TranslatePendencyTreatmentStatusPipe,
  ],
  providers: [
    FirstNamePipe,
    FromNowPipe,
    RemainingTimePipe,
    TranslatePendencyTreatmentStatusPipe,
  ]
})
export class PipesModule { }
